import { createSelector } from 'reselect';
import { getOrganization, ORGANIZATION_NAMESPACE } from '../../OrganizationData.js';
import Api from './Api';

export const CALENDER_PREFERENCES = 'calendar_preferences';

export const getCalendarPreferences = createSelector(getOrganization, (organization) => {
  return organization[CALENDER_PREFERENCES] || {};
});

export const fetchCalendarPreferences = {
  fetchingApiFunc: Api.show,
  selector: getCalendarPreferences,
  paramsFromProps: (props) => [props.pro.id],
  dataNamespace: ORGANIZATION_NAMESPACE,
  propertyName: CALENDER_PREFERENCES,
};
